import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Button, CancelButton } from 'shared/mui/Buttons';
import { Card, CardActionsButtons, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { Dialog, DialogProps } from 'shared/mui/Dialogs';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { Typography } from 'shared/mui/Typography';
import { useSyncNestedDialogState } from 'shared/widgets/CommissionsTabs/context/CommissionsNestedDialogsContext';
import { CommissionRecalculationTask } from 'types/embedded/commissionRecalculationTask';

type Props = {
  onClose: VoidFunction;
  onShow: (record: CommissionRecalculationTask | undefined) => void;
  record: CommissionRecalculationTask | undefined;
} & DialogProps;

export const CommissionsTabsTaskCreateSuccessDialog: React.FC<Props> = ({
  open,
  onClose,
  onShow,
  record,
}) => {
  const translate = useTypedTranslate();

  useSyncNestedDialogState(open);

  return (
    <Dialog onClose={onClose} open={open} width="640px">
      <Card>
        <CardHeader
          appendActions={[<CloseIconButton key="close-button" onClose={onClose} />]}
          title={translate('app.commissionsRecalculation.successDialog.title')}
          titleSize="smallBold"
        />
        <CardContent>
          <Typography>{translate('app.commissionsRecalculation.successDialog.message')}</Typography>
        </CardContent>
        <CardActionsButtons
          rightActionsSlot={[
            <CancelButton key="cancel-button" onClick={onClose} variant="outlined" />,
            <Button
              color="primary"
              isLoading={false}
              key="save-button"
              label={translate('app.commissionsRecalculation.successDialog.show')}
              onClick={() => {
                onShow(record);
              }}
              variant="contained"
            />,
          ]}
        />
      </Card>
    </Dialog>
  );
};
